import * as React from 'react';
import tw, { styled } from 'twin.macro';
import 'styled-components/macro';

const Background = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  ${tw`bg-blue`}
  width: 100%;
  height: 100%;
  box-sizing: border-box;
`;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  overflow-x: auto;
  width: auto;
  height: 100%;
  padding: 20px;
  box-sizing: border-box;

  @media (min-width: 1024px) {
    padding: 20px 100px;
  }
`;

const Label = styled.label`
  display: flex;
  align-content: stretch;
  align-items: center;
  width: 100%;
`;

const Answers = styled.div`
  margin: 0;
  padding: 30px 0;
  box-sizing: border-box;
  display: flex;
  ${tw`border-b-1`}
  ${tw`border-solid`}
  ${tw`border-b-blue-light`}

  input {
    position: absolute;
    visibility: hidden;
  }

  input:checked ~ div {
    ${tw`border-green`};

    &:before {
      ${tw`bg-green`};
    }
  }
`;

const Check = styled.div`
  display: block;
  position: relative;
  border: 5px solid #aaaaaa;
  border-radius: 30%;
  height: 30px;
  width: 30px;
  transition: border 0.25s linear;
  -webkit-transition: border 0.25s linear;
  flex-shrink: 0;

  &:before {
    display: block;
    position: absolute;
    content: '';
    border-radius: 20%;
    height: 10px;
    width: 10px;
    top: 5px;
    left: 5px;
    margin: auto;
    transition: background 0.25s linear;
    -webkit-transition: background 0.25s linear;
  }
`;

const Answer = styled.span`
  align-self: center;
  font-size: 16px;
  font-weight: 400;
  margin: 0 0 0 15px;
  color: ${props => props.theme.colors.gray.base};
  flex-grow: 1;

  @media (min-width: 1024px) {
    font-size: 24px;
  }
`;

const Description = styled.p`
  font-size: 16px;
  color: ${props => props.theme.colors.gray.dark};
  margin: 40px 0 0;
  text-align: center;
`;

export interface TabContentQuizProps {
  answers: string[];
  onQuizAnswerChange(e: React.ChangeEvent<HTMLInputElement>, index: number): void;
}

export const TabContentQuiz = ({ answers, onQuizAnswerChange }: TabContentQuizProps) => (
  <Background>
    <Container>
      {answers.map((answer, index) => (
        <Answers key={index}>
          <Label htmlFor={`quiz-${index}`}>
            <input type="checkbox" name="quiz" id={`quiz-${index}`} onChange={e => onQuizAnswerChange(e, index)} />
            <Check />
            <Answer>{answer}</Answer>
          </Label>
        </Answers>
      ))}

      <Description>Multiple answers can be checked as correct.</Description>
    </Container>
  </Background>
);
